(function () {
  'use strict';
  var controller;
  function shouldShow(scrollY) { return Number(scrollY) >= 600; }
  function scrollBehavior(reducedMotion) { return reducedMotion ? 'auto' : 'smooth'; }
  function tidioBottomOffset(viewportHeight, rect) {
    if (!rect || !Number.isFinite(Number(viewportHeight)) || !Number.isFinite(Number(rect.top)) || Number(rect.top) < 0 || Number(rect.width) <= 0 || Number(rect.height) <= 0) return null;
    return Math.max(0, Number(viewportHeight) - Number(rect.top) + 20);
  }
  function initialize() {
    if (controller) controller.destroy();
    var button = document.querySelector('[data-scroll-to-top]');
    if (!button) return null;
    var ticking = false;
    var positionTicking = false;
    var positionFrame;
    var tidioHost;
    var tidioLauncher;
    var documentObserver;
    var shadowObserver;
    var resizeObserver;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    function render() {
      ticking = false;
      var visible = shouldShow(window.scrollY);
      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', String(!visible));
      button.tabIndex = visible ? 0 : -1;
    }
    function requestRender() {
      if (ticking) return;
      ticking = true;
      (window.requestAnimationFrame || function (callback) { callback(); })(render);
    }
    function measureTidio() {
      positionTicking = false;
      var offset = tidioLauncher ? tidioBottomOffset(window.innerHeight, tidioLauncher.getBoundingClientRect()) : null;
      if (offset === null) document.documentElement.style.removeProperty('--scroll-top-bottom');
      else document.documentElement.style.setProperty('--scroll-top-bottom', offset + 'px');
    }
    function requestPosition() {
      if (positionTicking) return;
      positionTicking = true;
      positionFrame = (window.requestAnimationFrame || function (callback) { callback(); return null; })(measureTidio);
    }
    function connectTidio() {
      var nextHost = document.querySelector('#tidio-chat');
      var nextLauncher = nextHost && nextHost.shadowRoot && nextHost.shadowRoot.querySelector('#button-body');
      if (!nextLauncher) { requestPosition(); return; }
      if (nextHost === tidioHost && nextLauncher === tidioLauncher) { requestPosition(); return; }
      if (shadowObserver) shadowObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      tidioHost = nextHost; tidioLauncher = nextLauncher;
      if (documentObserver) documentObserver.disconnect();
      shadowObserver = new MutationObserver(requestPosition);
      shadowObserver.observe(tidioHost.shadowRoot, { attributes: true, childList: true, subtree: true });
      if (window.ResizeObserver) { resizeObserver = new ResizeObserver(requestPosition); resizeObserver.observe(tidioLauncher); resizeObserver.observe(tidioHost); }
      requestPosition();
    }
    function scrollTop() {
      window.scrollTo({ top: 0, behavior: scrollBehavior(Boolean(reducedMotion && reducedMotion.matches)) });
    }
    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', requestPosition);
    button.addEventListener('click', scrollTop);
    document.body.classList.add('has-native-floating-controls');
    documentObserver = new MutationObserver(connectTidio);
    documentObserver.observe(document.documentElement, { childList: true, subtree: true });
    connectTidio();
    render();
    controller = { destroy: function () {
      window.removeEventListener('scroll', requestRender);
      window.removeEventListener('resize', requestPosition);
      button.removeEventListener('click', scrollTop);
      if (documentObserver) documentObserver.disconnect();
      if (shadowObserver) shadowObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      if (positionFrame && window.cancelAnimationFrame) window.cancelAnimationFrame(positionFrame);
      document.documentElement.style.removeProperty('--scroll-top-bottom');
      document.body.classList.remove('has-native-floating-controls');
    } };
    return controller;
  }
  var api = { shouldShow: shouldShow, scrollBehavior: scrollBehavior, tidioBottomOffset: tidioBottomOffset, initialize: initialize };
  if (window.__BBG_FLOATING_CONTROLS_TEST__) window.BBGFloatingControlsTest = api;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
}());
